/**
 * sessao.js — duas decisões pequenas que estavam erradas em silêncio (Onda 95)
 *
 * Em 19/09/2026 o Iatagã recebeu "Erro ao fazer login" em g2.acessoid.com.br. O
 * login estava certo: o servidor é que não respondia (trecho VPS → VPN), e a
 * tela dava a mesma mensagem para isso e para um erro 500. Antes disso, a sessão
 * dele tinha vencido no teto de 7 dias da Onda 85 — e o token vencido devolve
 * **403**, que o interceptor ignorava: só o 401 levava ao login. Quem estava com
 * a tela aberta ficava com as chamadas falhando caladas até recarregar.
 *
 * As duas funções são puras para poderem ser testadas sem navegador.
 */

// O backend marca com `code` os 403 que encerram a sessão (middleware/auth.js).
// O texto fica como segunda via para um backend ainda sem a marca — o deploy do
// frontend e o do backend não são atômicos.
const CODIGOS_QUE_ENCERRAM = ['token_invalid', 'account_inactive'];
const TEXTOS_QUE_ENCERRAM = ['Token inválido ou expirado', 'Conta inativa ou inexistente'];

/**
 * A resposta diz que a sessão acabou? 401 sempre; 403 só quando é do token ou da
 * conta — um 403 de "Permissão negada" é de quem está logado e sem alçada, e
 * derrubá-lo para o login seria trocar um aviso por uma expulsão.
 */
export function sessaoEncerrada(error) {
  const status = error?.response?.status;
  if (status === 401) return true;
  if (status !== 403) return false;
  const corpo = error.response.data || {};
  return CODIGOS_QUE_ENCERRAM.includes(corpo.code) || TEXTOS_QUE_ENCERRAM.includes(corpo.error);
}

/** O que dizer a quem tentou entrar e não conseguiu. */
export function mensagemDeLogin(error) {
  if (error?.response) {
    return error.response.data?.error || 'Erro ao fazer login';
  }
  if (error?.code === 'ECONNABORTED') {
    return 'O servidor demorou a responder. Sua senha não foi recusada — tente novamente.';
  }
  return 'Sem resposta do servidor. Sua senha não foi recusada — verifique a conexão e tente novamente.';
}
